import React from 'react'
import { getDealTone, getFloorDealComparison, getRenovatedDealComparison } from '../../helpers/propertyDealScore'

const formatCompactPrice = (value) => {
  if (!Number.isFinite(Number(value))) return '—'
  if (Math.abs(Number(value)) >= 1000000) {
    return `${(Number(value) / 1000000).toLocaleString('cs-CZ', { minimumFractionDigits: 1, maximumFractionDigits: 2 })} mil. Kč`
  }
  return `${Math.round(Number(value)).toLocaleString('cs-CZ')} Kč`
}

const ScenarioSnippet = ({ title, summary, comparison, stale, refreshing, error }) => {
  const tone = getDealTone(comparison)
  if (!summary) {
    return (
      <div className="animate-pulse rounded-lg border border-gray-200 bg-gray-50 p-3">
        <div className="h-3 w-16 rounded bg-gray-200" />
        <div className="mt-3 h-4 w-24 rounded bg-gray-200" />
        <div className="mt-2 h-3 w-20 rounded bg-gray-200" />
      </div>
    )
  }

  return (
    <div className={`rounded-lg border p-3 ${tone.card}`}>
      <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-600">{title}</div>
      <div className={`mt-1 whitespace-nowrap text-sm font-semibold ${tone.price}`}>{formatCompactPrice(summary.anchorPrice)}</div>
      <div className="mt-0.5 text-[10px] text-gray-500">{Math.round(summary.anchorPpm2 || 0).toLocaleString('cs-CZ')} Kč/m²</div>
      {comparison?.shortLabel && <div className={`mt-2 inline-flex rounded-full px-2 py-1 text-[10px] font-medium ${tone.badge}`}>{comparison.shortLabel}</div>}
      {Number(summary.confidence) < 0.5 && <div className="mt-1 text-[10px] font-medium text-amber-800">Nízká důvěra {Math.round(Number(summary.confidence) * 100)} %</div>}
      {refreshing && <div className="mt-1 text-[10px] text-gray-500">Aktualizuji…</div>}
      {!refreshing && error && <div className="mt-1 text-[10px] text-red-700">Obnova selhala</div>}
      {!refreshing && !error && stale && <div className="mt-1 text-[10px] text-gray-500">Starší odhad</div>}
    </div>
  )
}

const PropertyValuationSnippet = ({ property }) => {
  const preview = property.valuationPreview
  if (!preview) return null

  const floorScenario = preview.scenarios?.floor
  const renovatedScenario = preview.scenarios?.renovated
  const floor = floorScenario?.summary
  const renovated = renovatedScenario?.summary
  const floorComparison = getFloorDealComparison(property.price, floor?.anchorPrice)
  const renovatedComparison =
    floor?.anchorPrice > 0 && renovated?.anchorPrice > 0 && renovated.anchorPrice <= floor.anchorPrice
      ? { tone: 'red', shortLabel: 'Nekonzistentní odhad' }
      : getRenovatedDealComparison(property.price, renovated?.anchorPrice)
  const refreshing = Boolean(preview.refreshNeeded || preview.refreshing)

  if (preview.status === 'error' && !floor && !renovated) {
    return <div className="lg:w-[360px] text-xs text-red-700">Odhady nejsou dostupné.</div>
  }

  return (
    <div className="mt-3 grid w-full grid-cols-2 gap-2 lg:mt-0 lg:w-[360px] lg:shrink-0">
      <ScenarioSnippet
        title="Spodní hranice odhadu"
        summary={floor}
        comparison={floorComparison}
        stale={floorScenario?.stale}
        refreshing={refreshing || floorScenario?.refreshing}
        error={floorScenario?.error}
      />
      <ScenarioSnippet
        title="Po rekonstrukci"
        summary={renovated}
        comparison={renovatedComparison}
        stale={renovatedScenario?.stale}
        refreshing={refreshing || renovatedScenario?.refreshing}
        error={renovatedScenario?.error}
      />
    </div>
  )
}

export default PropertyValuationSnippet
